export const DEFAULT_DISPLAY_THEME = 'default';

// The app shell stays on the standard default theme. Map/chart visual styles
// are configured separately, and accessibility color modes override this only
// through accessibilityTheme.config.js.
export const themes = [
  {
    name: 'Default',
    tName: 'default',
    value: {
      background: '#0b1826',
      base: '#222a2d',
      primaryShadow: '#1e374f',
      primary: '#325277',
      primaryHighlight: '#436c9a',
      primaryForeground: '#ffffff',
      primaryHighlightForeground: '#ffffff',
      fontColor: '#fff',
      divider: '#718096',
    },
  },
];

export const THEME_BY_KEY = themes.reduce(
  (themeMap, theme) => ({
    ...themeMap,
    [theme.tName]: theme,
  }),
  {},
);
